import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CancelIcon from "@mui/icons-material/Cancel";
import VisualCustomLineChart from "./VisualCustomLineChart";
import {
  generateLaborSummary,
  getDailyScheduleHourRange,
  get_t_str,
} from "../../../../helpers/helpers";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: 600,
  minHeight: 400,
  width: "98vw",
  maxWidth: 1800,
  height: "auto",
  maxHeight: "calc(100vh - 64px)",
  display: "flex",
  flexDirection: "column",
  overflowY: "auto",
  overflowX: "hidden",
  bgcolor: "background.paper",
  border: "2px solid #E2E8F0",
  borderRadius: "15px",
  boxShadow: 24,
  p: 3,
};

function VisualChartModal(props) {
  let data;
  let label1;
  let label2;
  if (props.earned_toggle) {
    label1 = "Earned";
    label2 = "Actual";
    data = generateLaborSummary(
      props.calculated_earned_labor_day,
      props.actual_used_labor_vs_earned_day,
      get_t_str,
      label1,
      label2
    );
  } else {
    label1 = "Forecasted";
    label2 = "Scheduled";
    data = generateLaborSummary(
      props.forecasted_labor_day,
      props.actual_schedule_labor_day,
      get_t_str,
      label1,
      label2
    );
  }
  const { start_h, end_h } = getDailyScheduleHourRange(
    props.dow_default_operating_hours,
    props.day_operating_hours,
    props.actual_schedule,
    0,
    24,
    data.summary
  );

  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <button
            type="button"
            aria-label="Close staffing chart"
            className="absolute right-4 top-4 z-50 flex h-8 w-8 items-center justify-center rounded-full bg-white/90 text-gray-500 hover:bg-slate-100"
            onClick={props.handleClose}
            style={{ zIndex: 1000 }}
          >
            <CancelIcon />
          </button>
          <VisualCustomLineChart
            data={data.summary}
            roleTypes={data.roleTypes}
            supportNames={data.supportNames}
            date_name={props.date_name}
            height="100%"
            isTable={false}
            label1={label1}
            label2={label2}
            start_h={start_h}
            end_h={end_h}
          />
        </Box>
      </Modal>
    </div>
  );
}

export default VisualChartModal;
